import movieTrailer from 'movie-trailer';
import React, { useState, useEffect  } from 'react'
import YouTube from 'react-youtube';
import axios from './axios'
import requests from './Requests';
// import YouTube from "rect-youtube";
// import movieTrailer from './movie-trailer';

const base_url = "https://image.tmdb.org/t/p/original/"
function Row ({title, fetchUrl, isLargeRow })  {
   const [movies, setMovies] = useState([]);
   const [trailer, setTrailerUrl, trailerUrl] = useState("");

   useEffect(() => {

    async function fetchData() {
        const request = await axios.get(fetchUrl);
        console.log(request.data.results);
        setMovies(request.data.results); 
        return requests;
    }
    fetchData(); 
   },  [ fetchUrl]);

   const opts = {
    hight: "390",
    widhth:"100%",
    playerVars:{
      autoplay:1,
    },
   };

   const handleClick = (movies) => {
    if (trailerUrl){
setTrailerUrl('');
    }
    else{
       movieTrailer(movies?.name || "")
       .then(url =>{
const urlParams = new URLSearchParams(new URL(url).search);
setTrailerUrl(urlParams.get('v'));
       }).catch(error =>console.error())
    }
   };

  //  console.log(movies); 
  
    return (
    <div className='row'>
        
      <h2>{title}</h2>
      <div className='row_posters'>
        {movies.map(movies =>(
          <img
          key={movies.id}
          onClick={()=>handleClick(movies)}
           className={`row_poster  ${isLargeRow && "row_posterLarge"} `}
          src={`${base_url}${isLargeRow ? movies.poster_path :movies.backdrop_path }`} alt={movies.name}/>
        )
          )}
      </div>
     {trailerUrl } <YouTube videoId={trailerUrl} opts={opts}/>
    </div>
  )
}

export default Row;
